import { GenericComponent } from '@/components/GenericComponent';
import { useClassName } from '@/styles/LayoutMain';
import { PropsFromComponent } from '@/types/component';

export type MainProps = PropsFromComponent<typeof Main>;

export const Main = GenericComponent({ as: 'main', styles: { useClassName } });
